import { todayFilterDateRange } from '@/shared/utils/date-range';
export const KPI_CHART_TYPES = ['bar', 'line', 'pie', 'doughnut'];
function parseChartColors(color) {
    if (!color)
        return '#888';
    if (color.includes(','))
        return color.split(',').map((c) => c.trim());
    return color;
}
export function apiChartToChartJs(chart) {
    if (!chart)
        return null;
    return {
        labels: chart.labels,
        datasets: chart.datasets.map((ds) => ({
            label: ds.label,
            data: ds.data,
            backgroundColor: parseChartColors(ds.backgroundColor),
            borderColor: parseChartColors(ds.borderColor),
            borderWidth: ds.borderWidth ?? 1,
            fill: chart.type !== 'line',
        })),
    };
}
function buildSummaryFromApi(raw) {
    const totalCalls = raw.totalCalls ?? 0;
    const totalAnswered = raw.answeredCalls ?? 0;
    const totalUnanswered = raw.unansweredCalls ?? 0;
    const formattedTotalDuration = raw.formattedTotalDuration?.trim() || '--';
    const overallAnswerRate = raw.answerRate ?? (totalCalls > 0 ? (totalAnswered / totalCalls) * 100 : 0);
    return {
        totalCalls,
        totalAnswered,
        totalUnanswered,
        formattedTotalDuration,
        overallAnswerRate,
    };
}
export function mapKpiDashboardResponse(raw) {
    return {
        summary: buildSummaryFromApi(raw),
        callStatusChart: raw.callStatusChart,
        performanceChart: raw.performanceChart,
        callDistributionChart: raw.callDistributionChart,
        hourlyDistributionChart: raw.hourlyDistributionChart,
        queueComparisonChart: raw.queueComparisonChart,
        satisfactionChart: raw.satisfactionChart,
    };
}
export function deriveKpiReferenceFromCharts(charts) {
    return {
        agents: [...charts.callStatusChart.labels].sort(),
        queues: [...charts.queueComparisonChart.labels].sort(),
        shifts: [],
        chartTypes: [...KPI_CHART_TYPES],
    };
}
export function mergeKpiReference(base, rows) {
    return {
        agents: [...new Set([...base.agents, ...rows.map((row) => row.agent)])].sort(),
        queues: [...new Set([...base.queues, ...rows.map((row) => row.queue)])].sort(),
        shifts: [...new Set([...base.shifts, ...rows.map((row) => row.shift)])].sort(),
        chartTypes: base.chartTypes,
    };
}
export function defaultKpiDateRange() {
    return todayFilterDateRange();
}
export function toKpiDateParam(d) {
    if (!d || Number.isNaN(d.getTime()))
        return undefined;
    return d.toISOString();
}
export function formatKpiPercent(n) {
    return new Intl.NumberFormat(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(n);
}
export function formatKpiCount(n) {
    return new Intl.NumberFormat().format(n);
}
export function formatDurationFromSeconds(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return [hours, minutes, seconds].map((n) => String(n).padStart(2, '0')).join(':');
}
export function kpiRateClass(rate) {
    if (rate >= 80)
        return 'text-green-600';
    if (rate >= 60)
        return 'text-yellow-500';
    return 'text-red-600';
}
